import React, { ReactNode, useMemo } from 'react'
import classNames from 'classnames'
import { ControlledHiddenInput } from 'transfix-form/components'
import { Typography } from 'transfix-ui/core'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { FP_FAQ_URL_DRIVER_LED_STATUS } from 'apps/fleet-planner/config'
import { useTeamMemberFormContext } from 'apps/fleet-planner/context/TeamMemberFormContext'
import { brandColors, Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui'
import { hasDrivers } from 'utils/teamMemberHelpers'
import ControlledDriverStatusUpdatesSwitch from './ControlledDriverStatusUpdatesSwitch'

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    backgroundColor: brandColors.coolGray1,
    display: 'grid',
    gap: spacing(3),
    padding: spacing(4),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
    marginBottom: spacing(1),
  },
}))

interface DriverStatusUpdatesSubFormProps {
  phoneInput: ReactNode
}

const MobilePhoneAndStatusUpdatesSubform = ({ phoneInput }: DriverStatusUpdatesSubFormProps) => {
  const { header, root } = useStyles()
  const { control, watch } = useTeamMemberFormContext()

  const motorCarrierDetails = watch('motorCarrierDetails')
  const isDriver = useMemo(() => hasDrivers(motorCarrierDetails), [motorCarrierDetails])
  const wrapperClasses = classNames({}, { [root]: isDriver })

  return (
    <div className={wrapperClasses}>
      {isDriver && (
        <div>
          <div className={header}>
            <Typography variant='h6'>Enable SMS Prompt to Ask for Status Updates</Typography>
            <Tag tagStyle={TAG_STYLE.success} size={TAG_SIZE.xsmall} label='Recommended' />
          </div>
          <Typography>
            We&apos;ll automatically text your driver a timely reminder at every stop to update
            their status. You&apos;ll receive an email when they arrive and depart each pickup and
            dropoff. If your driver tracks well or if you opt them out, we won&apos;t send a message
            and will just keep their phone number on file.{' '}
            <a href={FP_FAQ_URL_DRIVER_LED_STATUS} target='_blank' rel='noopener noreferrer'>
              <strong>Learn More</strong>
            </a>
          </Typography>
        </div>
      )}
      {phoneInput}
      {isDriver ? (
        <ControlledDriverStatusUpdatesSwitch />
      ) : (
        <ControlledHiddenInput
          control={control}
          name='smsStatusUpdatesEnabled'
          defaultValue={false}
        />
      )}
    </div>
  )
}

export default MobilePhoneAndStatusUpdatesSubform
